var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11c-1.467 0-2.722-.522-3.767-1.567-1.044-1.044-1.566-2.3-1.566-3.766 0-1.467.522-2.723 1.566-3.767C8.278.856 9.533.333 11 .333s2.722.523 3.767 1.567c1.044 1.044 1.566 2.3 1.566 3.767 0 1.466-.522 2.722-1.566 3.766C13.722 10.478 12.467 11 11 11ZM.333 21.667v-3.734c0-.755.195-1.45.584-2.084a3.885 3.885 0 0 1 1.55-1.449 19.822 19.822 0 0 1 4.2-1.55A18.367 18.367 0 0 1 11 12.332c1.467 0 2.911.172 4.333.516 1.423.345 2.822.862 4.2 1.551.645.333 1.161.816 1.55 1.45.389.633.584 1.328.584 2.083v3.734H.333ZM3 19h16v-1.067c0-.244-.06-.466-.183-.666a1.303 1.303 0 0 0-.484-.467c-1.2-.6-2.41-1.05-3.633-1.35a15.492 15.492 0 0 0-7.4 0c-1.222.3-2.433.75-3.633 1.35A1.292 1.292 0 0 0 3 17.933V19Zm8-10.667c.733 0 1.361-.261 1.884-.784.522-.521.783-1.149.783-1.882 0-.734-.261-1.361-.783-1.883A2.569 2.569 0 0 0 11 3c-.733 0-1.36.261-1.883.784a2.565 2.565 0 0 0-.784 1.883c0 .733.262 1.36.784 1.882.522.523 1.15.784 1.883.784Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.7c47239e3fef4e34723691ff60465e3a.svg";
export { ForwardRef as ReactComponent };